import "./tripSummary.css";
import { useEffect, useState } from "react";
import { withRouter, useParams, NavLink, Link } from "react-router-dom";
import { connect } from "react-redux";
import NotLoggedIn from "Components/notLoggedIn";
import main_yachtImg from "assets/Images/bg/main_yacht.jpg";
import cardLogos from "assets/Images/icons/stripLogos.png";
import { CustomRatings } from "Utills/CustomRatings";
import { Button } from "@material-ui/core";
import CustomInput from "Utills/CustomInput/CustomInput";
import { Helmet } from "react-helmet";

const TripSummary = (props) => {
  //
  const [payWithVisa, setPayWithVisa] = useState(false);
  const [formData, setFormData] = useState({
    paymentType: true,
  });
  // id
  let { id } = useParams();
  // user
  let user = props.current_user;
  const [summaryAvail, setSummaryAvail] = useState(false);

  //=================== check if Trip Summary id is available or not ===========================
  // id will be retrieve from Params/URL

  useEffect(() => {
    if (id) {
      setSummaryAvail(true);
    } else {
      setSummaryAvail(false);
    }
  }, [id]);
  // ============== Check user is logged in or not
  if (user && Object.values(user).length > 0 && user.is_captain) {
    return (
      <div className="tripSummary_page">
        <Helmet>
          <title>Cyan | My trip</title>
        </Helmet>
        {summaryAvail ? (
          <div className="cs_container">
            <div className="row justify-content-md-between justify-content-center">
              {/* left col */}
              <div className="trip_summary_left_col">
                {/*  */}
                <div className="with-left-border">
                  <h4 className="px-1 ">Your Trip</h4>
                  <div className="mt-3 p-2 mb-2 bg_pr_light rounded">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="text-pr fw-bold">Date</div>
                      <Link
                        to={`/yachtDetail/${id}`}
                        className="text-pr fw-bold pe-2"
                      >
                        Edit
                      </Link>
                    </div>
                    <div className="d-flex flex-wrap flex-md-nowrap text-gr">
                      <div>
                        <p className="fw-light">Oct 21th, 2021</p>
                        <p className="fw-light">Oct 21th, 2021</p>
                      </div>
                      <span className="px-md-5  trip_sum_light_card_text">
                        Intraday
                      </span>
                      <span>
                        09:00AM{" "}
                        <span className="text-sec p-2 fw-bold">
                          {" "}
                          <svg
                            width="7"
                            height="12"
                            viewBox="0 0 7 12"
                            fill="none"
                          >
                            <path
                              d="M0.170067 11.8299C-0.0360748 11.6238 -0.054815 11.3012 0.113847 11.0739L0.170067 11.0088L5.17858 6L0.170067 0.991223C-0.0360748 0.785082 -0.054815 0.462503 0.113847 0.235191L0.170067 0.170068C0.376209 -0.0360737 0.698787 -0.0548143 0.926099 0.113847L0.991223 0.170068L6.41058 5.58942C6.61672 5.79556 6.63546 6.11814 6.4668 6.34545L6.41058 6.41058L0.991223 11.8299C0.764467 12.0567 0.396823 12.0567 0.170067 11.8299Z"
                              fill="#3F8BBF"
                            />
                          </svg>
                        </span>{" "}
                        10:00AM
                      </span>
                    </div>
                  </div>
                  <div className="mt-2 p-2 mb-2 bg_pr_light rounded">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="text-pr fw-bold">Guest</div>
                      <Link
                        to={`/yachtDetail/${id}`}
                        className="text-pr fw-bold pe-2"
                      >
                        Edit
                      </Link>
                    </div>
                    <div className="d-flex text-gr">
                      <span>6</span>
                    </div>
                  </div>
                </div>
                {/* additional info */}
                {/* <div className="with-left-border mt-md-4 mt-3">
                  <h4 className="px-1">Additional Information</h4>
                  <div className="mt-2 px-3">
                    <h5 className="">Itinerary</h5>
                    <p className="mt-2">
                      <span className="text-pr">
                        The itinerary will be drawn and discussed with a Cyan
                        Representative once your payment is completed.{" "}
                      </span>
                      <br />A suggestion will be sent to go over it. If there
                      are some specific islands you wish to visit we try to
                      include them according to the days you will charter and
                      bearing in mind the distance to get there.
                    </p>
                  </div>
                  <div className="mt-2 px-3">
                    <h5 className="my-2">Provisions</h5>
                    <p className="mt-2">
                      <span className="text-pr">
                        A provisions list is sent to client for on board
                        provisioning.{" "}
                      </span>
                      Items selected will be provided on board by our crew.
                      <br />
                      The provisions are either settled by the{" "}
                      <span className="text-pr"> APA, </span> or by the client
                      cash once provisions are on board upon remittance of all
                      invoices by their captain.
                    </p>
                  </div>
                  <div className="mt-2 px-3">
                    <h5 className="my-2">Cruising</h5>
                    <p className="mt-2">
                      <span className="text-pr">
                        Usually we cruise during day
                      </span>{" "}
                      and dock at Ports allowing you to stroll at night in the
                      traditional villages as well as enjoy traditional taverns
                      or quoted restaurants, that our captains may suggest to
                      them.
                    </p>
                  </div>
                  <div className="mt-2 px-3">
                    <h5 className="my-2">Gratuities</h5>
                    <p className="mt-2">
                      <span className="text-pr">
                        Gratuities are not included in the cost of the charter.{" "}
                      </span>
                      The normal is between 10% & 15% of the base charter rate.
                      As with all service businesses, a gratuity should be given
                      if deserved. Gratuities should be made with cash.
                    </p>
                  </div>
                </div> */}

                {/* reserve info */}
                <div className="px-3 mt-md-5 mt-3">
                  <h5 className="text-gr">Reservation information</h5>
                  <div className="d-flex justify-content-start align-items-center mt-3">
                    <div className="col-md-2 col-3 text-muted">Name</div>
                    <p className="ps-md-2">Pipis</p>
                  </div>
                  <div className="d-flex mt-3 justify-content-start align-items-center">
                    <div className="col-md-2 col-3 text-muted">Surname</div>
                    <p className="ps-md-2">Efthimis</p>
                  </div>
                  <div className="d-flex mt-3 justify-content-start align-items-center">
                    <div className="col-md-2 col-3 text-muted">Email</div>
                    <p className="ps-md-2">piponotonefthimi@gmail.com</p>
                  </div>
                  <div className="d-flex mt-3 justify-content-start align-items-center">
                    <div className="col-md-2 col-3 text-muted">
                      Phone number
                    </div>
                    <p className="ps-md-2">+ 30 6945334234</p>
                  </div>
                </div>
                {/*  */}
                <div className="with-left-border  mt-md-5 mt-4">
                  <h4 className="px-1">Comment</h4>
                  <h6 className="px-1 py-2 text-muted">Message the Host</h6>
                  <p className="pt-2 fw-normal px-2 text-gr">
                    Let the host know why you are booking
                  </p>
                  <div className="boat-desc-wrappper mid-height mt-1 p-0">
                    <p className="text-muted ps-2">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Tincidunt nulla ipsum at scelerisque at leo amet. Iaculis
                      augue lectus amet.
                      <br />
                      <br />
                      eget feugiat faucibus odio eu proin nunc. Leo, lorem
                      mauris bibendum interdum porta duis tristique rhoncus.
                      Tortor a, dictumst convallis viverra
                    </p>
                  </div>
                </div>
                {/*  */}
                <div className="with-left-border  mt-md-5 mt-4">
                  <h4 className="px-1">Cancellation policy</h4>
                  <p className="pt-2 fw-light px-2">
                    <span className="text-pr fw-bold">
                      Free cancellation before 3:00 PM on Oct 20th.
                    </span>{" "}
                    After that, cancel before 3:00 PM on Oct 21th get full
                    refund, minus first night and service fee
                  </p>
                  <p className="px-2 text-muted fw-light mt-3">
                    Our Extenuation circumstances policy doesn not cover travel
                    disruptions caused by covid 19.
                  </p>
                </div>
                <div className="px-3 mt-4">
                  <hr className="cs_hr" />
                </div>
                {/*  */}
                <div className="d-flex flex-wrap p-3 pt-0">
                  <div className=" pb-3">
                    <svg width="33" height="38" viewBox="0 0 33 38" fill="none">
                      <path
                        opacity="0.2"
                        d="M26.5077 33.2053L22.6172 29.3149V23.5244H24.4267V28.573L27.7743 31.9206L26.5077 33.2053ZM23.5219 16.2863C24.1372 16.2863 24.7343 16.3406 25.3315 16.4311V7.23868H21.7124V12.6672H7.23623V7.23868H3.61719V34.3815H12.0858C11.1677 32.4517 10.7532 30.3208 10.8809 28.1876C11.0086 26.0543 11.6743 23.9881 12.816 22.1816C13.9578 20.3751 15.5383 18.887 17.4103 17.8562C19.2823 16.8254 21.3849 16.2853 23.5219 16.2863ZM14.4743 7.23868C13.4791 7.23868 12.6648 6.42439 12.6648 5.42915C12.6648 4.43391 13.4791 3.61963 14.4743 3.61963C15.4696 3.61963 16.2839 4.43391 16.2839 5.42915C16.2839 6.42439 15.4696 7.23868 14.4743 7.23868Z"
                        fill="#92B9D5"
                      />
                      <path
                        d="M23.5238 19.9048C18.5295 19.9048 14.4762 23.9581 14.4762 28.9524C14.4762 33.9467 18.5295 38 23.5238 38C28.5181 38 32.5714 33.9467 32.5714 28.9524C32.5714 23.9581 28.5181 19.9048 23.5238 19.9048ZM26.5095 33.2048L22.619 29.3143V23.5238H24.4286V28.5724L27.7762 31.92L26.5095 33.2048ZM25.3333 3.61905H19.579C18.819 1.52 16.8286 0 14.4762 0C12.1238 0 10.1333 1.52 9.37333 3.61905H3.61905C1.62857 3.61905 0 5.24762 0 7.2381V34.381C0 36.3714 1.62857 38 3.61905 38H14.6752C13.6047 36.9609 12.7338 35.7342 12.1057 34.381H3.61905V7.2381H7.23809V12.6667H21.7143V7.2381H25.3333V16.4305C26.6181 16.6114 27.8305 16.9914 28.9524 17.5162V7.2381C28.9524 5.24762 27.3238 3.61905 25.3333 3.61905ZM14.4762 7.2381C13.481 7.2381 12.6667 6.42381 12.6667 5.42857C12.6667 4.43333 13.481 3.61905 14.4762 3.61905C15.4714 3.61905 16.2857 4.43333 16.2857 5.42857C16.2857 6.42381 15.4714 7.2381 14.4762 7.2381Z"
                        fill="#3F8BBF"
                      />
                    </svg>
                  </div>
                  <div className="col-md-10 col-12">
                    <h5 className="px-2">
                      Your reservation won’t be confirmed until the host accepts
                      your request (within 24 hours)
                    </h5>
                    <p className="text-gr px-2 fw-normal my-2">
                      your wont be charged until then
                    </p>
                  </div>
                </div>
                {/*  */}
                <div className="mt-md-4 mt-3 ps-3 text-gr">
                  <p>
                    By selecting the button below, I agree to the{" "}
                    <NavLink className="fw-bold text-pr" to="/" target="_blank">
                      {" "}
                      CYAN Rules.{" "}
                    </NavLink>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Donec vestibulum congue dolor nunc amet.
                  </p>
                </div>
              </div>
              {/* righ col */}
              <div className="trip_summary_right_col">
                <div className="sticky_wrapper mb-3">
                  <div className="overAll_trip_summary_card mx-auto">
                    <div className="d-flex trip_summary_card_top">
                      <div className="col-4">
                        <div className="card_image_square_small">
                          <img src={main_yachtImg} alt="CYAN yacht" />
                        </div>
                      </div>
                      <div className="col-8 px-3">
                        <h4>Motorboat Azimut 62</h4>
                        <p className="text-sec pt-2">Crete . Greece</p>
                        <div className="d-flex flex-wrap w-100">
                          <p className="py-2">
                            12 <span className="text-gr"> people .</span>
                          </p>
                          <p className="py-2 px-md-2">
                            1 <span className="text-gr"> horsepower .</span>
                          </p>
                          <p className="py-2 px-md-2">
                            8 <span className="text-gr"> meters</span>
                          </p>
                        </div>
                        <div className="d-flex flex-wrap w-100 py-md-2 py-1">
                          <CustomRatings name="read-only" value={5} readOnly />
                          <p className="px-1">
                            5 <span className="text-gr px-1">( 23 )</span>
                          </p>
                        </div>
                        {/* <div className="d-flex flex-wrap w-100">
                        <p className="py-2 w-50 text-gr">Status</p>
                        <p className="py-2 w-50 fw-normal text-warning">
                          Pending
                        </p>
                      </div> */}
                      </div>
                    </div>
                    <hr className="cs_hr" />
                    <div className="pb-3  px-2">
                      {/* <div className="w-75">
                        <hr className="cs_hr" />
                      </div> */}
                      <h5>Price Details</h5>
                      <div className="py-2 text-muted d-flex flex-wrap">
                        <p className="w-50 py-1">1 hour x € 200</p>
                        <p className="w-50 py-1 text-right text-gr"> € 200</p>
                        {/*  */}
                        <p className="w-50 py-1">Extras</p>
                        <p className="w-50 py-1 text-right text-gr"> € 100</p>
                        <ul className="w-100">
                          <li className="w-100">transfers</li>
                        </ul>
                        {/*  */}

                        {/*  */}
                        <p className="w-50 py-1">Service fee</p>
                        <p className="w-50 py-1 text-right text-gr"> € 75</p>
                        {/*  */}
                        {/* <p className="w-50 py-1">Extras</p>
                      <p className="w-50 py-1 text-right"> € 0</p>
                      <p className="w-50 py-1">Service Fee</p>
                      <p className="w-50 py-1 text-right"> € 75.00</p> */}
                      </div>
                      <div className=" d-flex flex-wrap">
                        <h5 className="w-50 py-1">Total ( EUR )</h5>
                        <h5 className="w-50 fw-bold py-1 text-pr text-right">
                          {" "}
                          € 275.00
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div className="row mx-4 mt-3 justify-content-center align-items-center">
                    <div className="col-6 px-2">
                      <button className="join_become_btn rounded-3 py-2 w-100 signin_in_btn">
                        Accept
                      </button>
                    </div>
                    <div className="col-6 px-2">
                      <button className="cs_btn bg-danger py-2 w-100 rounded">
                        Decline
                      </button>
                    </div>
                    <div className="col-6 mx-auto mt-3">
                      <button className="cs_btn bg-dark py-2 w-100 rounded">
                        Cancel the trip
                      </button>
                    </div>
                  </div>
                  {/* <div className="my-3 mx-auto text-center">
                    <img className="img-fluid mx-auto" src={cardLogos} alt="" />
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="container">
            <div className="row">
              <div className="col-12 text-center text-pr">
                <h5 className="py-4">Trip ID not found!!</h5>
                <Button
                  variant="contained"
                  component={Link}
                  to="/"
                  color="primary"
                >
                  Visit Site
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  } else {
    // This will show when user is not logged in
    return <NotLoggedIn />;
  }
};

// Redux store config
const mapStateToProps = (store) => ({
  current_user: store.current_user,
});

export default connect(mapStateToProps, null)(withRouter(TripSummary));
